import React from 'react';

export default function NavigateButton({onClick = () => {}, active = false}) {
  return <a style={{border: 'none'}}
    onClick={onClick}
    className={active ? 'active' : ''}>&nbsp;</a>;
};
